var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatCopyHoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#24B8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6486 19.3514V8H21.7297V19.3514H12.6486ZM13.7837 18.2163H20.5946V9.13512H13.7837V18.2163ZM10 22V10.8815H11.1351V20.8649H18.8482V22H10Z",
    fill: "#24B8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCopyHoverIcon);
export default __webpack_public_path__ + "static/media/chatCopyHoverIcon.2a89bd55ba01df2f5946991632b692f5.svg";
export { ForwardRef as ReactComponent };